import { IconSize, IconProps } from "../theme";

const BubbleChevronUp: React.FC<IconProps> = ({ size = IconSize.S }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 6L6.70711 1.70711C6.31658 1.31658 5.68342 1.31658 5.29289 1.70711L1 6"
        stroke="#302B5D"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BubbleChevronUp;
